import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../../services/security.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private securityService:SecurityService,private route:Router) { }

  ngOnInit(): void {
    // this.securityService.isLoaded=false;
  }

  login(userGmin:any){
    // this.securityService.getCurrentUser(userGmin).subscribe(response=>{
    //   this.securityService.LOGGED_USER=response;
    //   this.securityService.LOGGED_USER.displayName=this.securityService.LOGGED_USER.firstName.concat(' ').concat(this.securityService.LOGGED_USER.lastName);
    //   this.securityService.LOGGED_USER.roles=[this.securityService.LOGGED_USER.roleName];
    //   this.securityService.isLoaded=true;
    //   this.route.navigate(['/home']);
    // });
  }

}
